import { useContext } from "react";
import { AuthProviderContext } from "..";

/**
 * Get the authProvider stored in the context
 */
const useOCPAuthProvider = () => useContext(AuthProviderContext)?.authProvider;

export default useOCPAuthProvider;
